export default __webpack_public_path__ + "static/media/ds-koseki.210153da.jpg";